import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  id: "modal-popup__content",
  class: "w-full max-w-[90vw] !overflow-y-visible tablet:max-w-600"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "border-b border-black-300 py-12 px-16 tablet:py-18 tablet:px-24" }
const _hoisted_4 = { class: "text-22 tablet:text-26" }
const _hoisted_5 = { class: "py-24 px-16 tablet:px-24" }
const _hoisted_6 = { class: "text-16 tablet:text-18" }
const _hoisted_7 = { class: "mt-32 flex justify-end gap-x-12" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "border-b border-black-300 py-12 px-16 tablet:py-18 tablet:px-24" }
const _hoisted_11 = { class: "text-22 tablet:text-26" }
const _hoisted_12 = { class: "py-24 px-16 tablet:px-24" }
const _hoisted_13 = { class: "flex flex-col overflow-hidden" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "overflow-hidden" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "border-b border-black-300 py-12 px-16 tablet:py-18 tablet:px-24" }
const _hoisted_20 = { class: "text-22 tablet:text-26" }
const _hoisted_21 = { class: "py-24 px-16 tablet:px-24" }
const _hoisted_22 = { class: "text-16 tablet:text-18" }
const _hoisted_23 = { class: "mt-32 flex justify-end gap-x-12" }
const _hoisted_24 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    id: "modal-popup",
    class: _normalizeClass(["flex", {open: $props.status === 'OPENED'}]),
    onClick: _cache[9] || (_cache[9] = _withModifiers($event => (_ctx.$emit('updateModal', 'CLOSED')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "absolute top-24 right-16 tablet:top-32 tablet:right-24",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('updateModal', 'CLOSED')))
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("svg", {
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none"
        }, [
          _createElementVNode("path", {
            d: "M11.25 11.25L0.75 0.75M11.25 0.75L0.75 11.25",
            stroke: "#121212",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ])),
      ($props.type === 'CONFIRM_REDIRECTION')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString($data.locale.confirm_redirection), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString($data.locale.return_to_homepage_confirmation), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn btn-secondary btn-small border-2 border-black-900 text-center",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('updateModal', 'CLOSED')))
                }, _toDisplayString($data.locale.cancel_button), 1),
                _createElementVNode("a", {
                  href: $data.homepageUrl,
                  class: "btn btn-primary btn-small text-center"
                }, _toDisplayString($data.locale.confirm_button), 9, _hoisted_8)
              ])
            ])
          ]))
        : ($props.type === 'SELECT_REASON')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString($data.locale.return_reason_modal_title), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "mb-12 flex w-full items-center justify-between border-b border-black-300 py-4 font-medium",
                  onClick: _cache[2] || (_cache[2] = $event => ($data.isSelectReasonDropdownOpen = !$data.isSelectReasonDropdownOpen))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                'before:mr-4 before:text-orange before:content-asterisk':
                  !$data.selectedReason && !$data.otherReason?.trim().length,
              })
                  }, [
                    ($data.selectedReason)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString($data.selectedReason), 1)
                        ], 64))
                      : ($data.isOtherReasonOptionSelected)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString($data.locale.return_reason_other_reason_input_label), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString($data.locale.return_reason_select_label), 1)
                          ], 64))
                  ], 2),
                  (_openBlock(), _createElementBlock("svg", {
                    width: "14",
                    height: "10",
                    viewBox: "0 0 16 10",
                    fill: "none",
                    class: _normalizeClass(["transition-transform duration-200 ease-in-out", {'rotate-180': $data.isSelectReasonDropdownOpen}])
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("path", {
                      d: "M1.25 1.625L8 8.375L14.75 1.625",
                      stroke: "#121212",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ]), 2))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["grid transition-grid-template-rows duration-500", $data.isSelectReasonDropdownOpen ? 'grid-rows-1' : 'grid-rows-0'])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.reasonOptions, (reason) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: reason,
                        tabindex: "0",
                        class: _normalizeClass(["cursor-pointer rounded-4 py-10 outline-none transition-all duration-200 hover:bg-black-100 focus-visible:bg-black-100", {'pointer-events-none bg-black-100 pl-6': reason === $data.selectedReason}]),
                        onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($data.isOtherReasonOptionSelected = false), ["self"]))
                      }, [
                        _createTextVNode(_toDisplayString(reason) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedReason) = $event)),
                          tabindex: "-1",
                          value: reason,
                          type: "radio",
                          name: "reason",
                          class: "visually-hidden"
                        }, null, 8, _hoisted_14), [
                          [_vModelRadio, $data.selectedReason]
                        ])
                      ], 2))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["w-full rounded-4 py-10 text-left outline-none transition-all duration-200 hover:bg-black-100 focus-visible:bg-black-100", {'pointer-events-none bg-black-100 pl-6': $data.isOtherReasonOptionSelected}]),
                      onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => ($options.openOtherReasonOption && $options.openOtherReasonOption(...args)), ["stop"]))
                    }, _toDisplayString($data.locale.return_reason_other_reason_input_label), 3),
                    _createElementVNode("div", {
                      class: _normalizeClass(["mt-12 grid transition-grid-template-rows duration-500", $data.isOtherReasonOptionSelected ? 'grid-rows-1' : 'grid-rows-0'])
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.otherReason) = $event)),
                          class: "mt-12 w-full resize-none border border-black-400 py-8 px-16 text-16 focus:border-black-900 focus-visible:outline-none",
                          rows: "7",
                          placeholder: $data.locale.return_reason_other_reason_input_placeholder
                        }, null, 8, _hoisted_16), [
                          [_vModelText, $data.otherReason]
                        ])
                      ])
                    ], 2)
                  ])
                ], 2),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-small mt-20 ml-auto",
                  disabled: !$options.userSelection,
                  onClick: _cache[7] || (_cache[7] = (...args) => ($options.confirmReturnReason && $options.confirmReturnReason(...args)))
                }, _toDisplayString($data.locale.next_button), 9, _hoisted_17)
              ])
            ]))
          : ($props.type === 'CANCEL_REQUEST')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString($data.locale.cancel_request), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("p", _hoisted_22, _toDisplayString($data.locale.cancel_request_confirmation), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary btn-small border-2 border-black-900 text-center",
                      onClick: _cache[8] || (_cache[8] = $event => (_ctx.$emit('updateModal', 'CLOSED')))
                    }, _toDisplayString($data.locale.cancel_button), 1),
                    _createElementVNode("a", {
                      href: $data.homepageUrl,
                      class: "btn btn-primary btn-small text-center"
                    }, _toDisplayString($data.locale.confirm_button), 9, _hoisted_24)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ], 2))
}